/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root';
import { Route as LoginRouteImport } from './app/login';
import { Route as AuthRouteImport } from './app/_auth';
import { Route as AuthIndexRouteImport } from './app/_auth.index';
import { Route as AuthTasksRouteImport } from './app/_auth.tasks';
import { Route as AuthOverviewRouteImport } from './app/_auth.overview';
import { Route as AuthOutagesRouteImport } from './app/_auth.outages';
import { Route as AuthOltsRouteImport } from './app/_auth.olts';
import { Route as AuthFleetRouteImport } from './app/_auth.fleet';
import { Route as AuthCtosRouteImport } from './app/_auth.ctos';
import { Route as AuthCockpitRouteImport } from './app/_auth.cockpit';
import { Route as AuthAlarmesRouteImport } from './app/_auth.alarmes';

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthTasksRoute = AuthTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthRoute,
} as any);
const AuthOverviewRoute = AuthOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthRoute,
} as any);
const AuthOutagesRoute = AuthOutagesRouteImport.update({
  id: '/outages',
  path: '/outages',
  getParentRoute: () => AuthRoute,
} as any);
const AuthOltsRoute = AuthOltsRouteImport.update({
  id: '/olts',
  path: '/olts',
  getParentRoute: () => AuthRoute,
} as any);
const AuthFleetRoute = AuthFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AuthRoute,
} as any);
const AuthCtosRoute = AuthCtosRouteImport.update({
  id: '/ctos',
  path: '/ctos',
  getParentRoute: () => AuthRoute,
} as any);
const AuthCockpitRoute = AuthCockpitRouteImport.update({
  id: '/cockpit',
  path: '/cockpit',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAlarmesRoute = AuthAlarmesRouteImport.update({
  id: '/alarmes',
  path: '/alarmes',
  getParentRoute: () => AuthRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute;
  '/login': typeof LoginRoute;
  '/alarmes': typeof AuthAlarmesRoute;
  '/cockpit': typeof AuthCockpitRoute;
  '/ctos': typeof AuthCtosRoute;
  '/fleet': typeof AuthFleetRoute;
  '/olts': typeof AuthOltsRoute;
  '/outages': typeof AuthOutagesRoute;
  '/overview': typeof AuthOverviewRoute;
  '/tasks': typeof AuthTasksRoute;
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute;
  '/alarmes': typeof AuthAlarmesRoute;
  '/cockpit': typeof AuthCockpitRoute;
  '/ctos': typeof AuthCtosRoute;
  '/fleet': typeof AuthFleetRoute;
  '/olts': typeof AuthOltsRoute;
  '/outages': typeof AuthOutagesRoute;
  '/overview': typeof AuthOverviewRoute;
  '/tasks': typeof AuthTasksRoute;
  '/': typeof AuthIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_auth': typeof AuthRouteWithChildren;
  '/login': typeof LoginRoute;
  '/_auth/alarmes': typeof AuthAlarmesRoute;
  '/_auth/cockpit': typeof AuthCockpitRoute;
  '/_auth/ctos': typeof AuthCtosRoute;
  '/_auth/fleet': typeof AuthFleetRoute;
  '/_auth/olts': typeof AuthOltsRoute;
  '/_auth/outages': typeof AuthOutagesRoute;
  '/_auth/overview': typeof AuthOverviewRoute;
  '/_auth/tasks': typeof AuthTasksRoute;
  '/_auth/': typeof AuthIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/login'
    | '/alarmes'
    | '/cockpit'
    | '/ctos'
    | '/fleet'
    | '/olts'
    | '/outages'
    | '/overview'
    | '/tasks';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/login'
    | '/alarmes'
    | '/cockpit'
    | '/ctos'
    | '/fleet'
    | '/olts'
    | '/outages'
    | '/overview'
    | '/tasks'
    | '/';
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/alarmes'
    | '/_auth/cockpit'
    | '/_auth/ctos'
    | '/_auth/fleet'
    | '/_auth/olts'
    | '/_auth/outages'
    | '/_auth/overview'
    | '/_auth/tasks'
    | '/_auth/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth/': {
      id: '/_auth/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/tasks': {
      id: '/_auth/tasks';
      path: '/tasks';
      fullPath: '/tasks';
      preLoaderRoute: typeof AuthTasksRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/overview': {
      id: '/_auth/overview';
      path: '/overview';
      fullPath: '/overview';
      preLoaderRoute: typeof AuthOverviewRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/outages': {
      id: '/_auth/outages';
      path: '/outages';
      fullPath: '/outages';
      preLoaderRoute: typeof AuthOutagesRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/olts': {
      id: '/_auth/olts';
      path: '/olts';
      fullPath: '/olts';
      preLoaderRoute: typeof AuthOltsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/fleet': {
      id: '/_auth/fleet';
      path: '/fleet';
      fullPath: '/fleet';
      preLoaderRoute: typeof AuthFleetRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/ctos': {
      id: '/_auth/ctos';
      path: '/ctos';
      fullPath: '/ctos';
      preLoaderRoute: typeof AuthCtosRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/cockpit': {
      id: '/_auth/cockpit';
      path: '/cockpit';
      fullPath: '/cockpit';
      preLoaderRoute: typeof AuthCockpitRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/alarmes': {
      id: '/_auth/alarmes';
      path: '/alarmes';
      fullPath: '/alarmes';
      preLoaderRoute: typeof AuthAlarmesRouteImport;
      parentRoute: typeof AuthRoute;
    };
  }
}

interface AuthRouteChildren {
  AuthAlarmesRoute: typeof AuthAlarmesRoute;
  AuthCockpitRoute: typeof AuthCockpitRoute;
  AuthCtosRoute: typeof AuthCtosRoute;
  AuthFleetRoute: typeof AuthFleetRoute;
  AuthOltsRoute: typeof AuthOltsRoute;
  AuthOutagesRoute: typeof AuthOutagesRoute;
  AuthOverviewRoute: typeof AuthOverviewRoute;
  AuthTasksRoute: typeof AuthTasksRoute;
  AuthIndexRoute: typeof AuthIndexRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAlarmesRoute: AuthAlarmesRoute,
  AuthCockpitRoute: AuthCockpitRoute,
  AuthCtosRoute: AuthCtosRoute,
  AuthFleetRoute: AuthFleetRoute,
  AuthOltsRoute: AuthOltsRoute,
  AuthOutagesRoute: AuthOutagesRoute,
  AuthOverviewRoute: AuthOverviewRoute,
  AuthTasksRoute: AuthTasksRoute,
  AuthIndexRoute: AuthIndexRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
